import React, { memo, type ReactElement } from 'react';
import { TabContent } from '@saviynt/design-system';
import cx from 'classnames';

import { SodSidePanelUser } from '../../../../shared/components';
import { VIOLATIONS_LIST_SIDEPANEL_TABS } from '../../../../shared/constants';
import { type ViolationsTabSidePanelRowContextState } from '../../data-layer/violationsTabTypes';

interface ViolationsSidePanelUserProps {
  currentRowContext: ViolationsTabSidePanelRowContextState;
  activeTab: string;
}

/**
 * ViolationsSidePanelUser
 */
function ViolationsSidePanelUser({
  currentRowContext,
  activeTab,
}: ViolationsSidePanelUserProps): ReactElement {
  const summaryTabClasses = cx(
    'Sod-ViolationsSidePanelBody-tabContent',
    'Sod-ViolationsSidePanelBody-tabContent--isUserTab'
  );

  return (
    <TabContent
      className={summaryTabClasses}
      value={activeTab}
      tabValue={VIOLATIONS_LIST_SIDEPANEL_TABS.TAB_USER}>
      <SodSidePanelUser
        usernameQuery={currentRowContext.username ?? ''}
        isInSidePanel
      />
    </TabContent>
  );
}

export default memo(ViolationsSidePanelUser);
